import { useContext } from 'react'
import cn from 'classnames'
import { FixedSpacer, Typography } from '@grammarly/badger-ui'
import { Icon, InterfaceOkIcon, Text } from '@grammarly/design-system'
import { getConfig } from '../../../../config'
import { SignUpGoogleButton } from '../../../item/cta-button/signup-google'
import { ButtonColor } from '../../../ui-lib/button'
import { SignUpProductRecButton } from '../../../item/cta-button/signup-product-recommendation'
import { PageContext } from '../../../../contexts/page-context'
import { gnarSpec } from '../../../../lib/tracking/gnar'
import { getSignupWallCopy } from './signup-wall-copy'

import styles from './signup.module.scss'

const config = getConfig()
const signinUrl = `${config.urls.main}/signin`

export const CtaLogInSupplement = ({ isIntoolLoginSupplement }: { isIntoolLoginSupplement?: boolean }) => {
  const { pageId, slug } = useContext(PageContext)

  if (isIntoolLoginSupplement) {
    return (
      <div className={styles.intoolLoginSupplement}>
        <Text as="p" variant="text-xsmall">
          Already have an account?{' '}
          <a
            className={styles.loginLink}
            href={signinUrl}
            rel="noreferrer noopener"
            onClick={() => gnarSpec.linkClick(pageId, slug, signinUrl, 'Log in', 'Modal')}
          >
            Log in
          </a>
        </Text>
      </div>
    )
  }

  return (
    <Typography.C5 className={styles.loginSupplement} as="div">
      Already have an account?{' '}
      <a
        className={styles.loginLink}
        href={signinUrl}
        rel="noreferrer noopener"
        onClick={() => gnarSpec.linkClick(pageId, slug, signinUrl, 'Log in', 'Modal')}
      >
        Log in
      </a>
    </Typography.C5>
  )
}

const CtaButtonGroup = () => {
  return (
    <>
      <SignUpProductRecButton
        color={ButtonColor.WDK24PrimaryLightBg}
        className={cn(styles.ctaButton)}
        text={<>Create an account</>}
        showArrow
        placement="Modal"
      />
      <FixedSpacer multiplier={2} />
      <SignUpGoogleButton text="Sign up with Google" className={styles.signUpWallGoogleButton} />
      <FixedSpacer multiplier={1} />
      <CtaLogInSupplement />
    </>
  )
}

export const SignUpModalContent = () => {
  const content = getSignupWallCopy()
  const dialogLabelId = 'dialog-title'

  return (
    <div className={styles.childrenContainer}>
      <Typography.C1 id={dialogLabelId} as="div" bold>
        {content.heading}
      </Typography.C1>
      {content.subheading && <Typography.C4 as="div">{content.subheading}</Typography.C4>}
      <FixedSpacer multiplier={3} />
      <ul className={styles.checklist}>
        {content.checklistItems.map((item, idx) => (
          <Typography.C4 key={idx} as="li">
            <div className={styles.checklistIcon}>
              <Icon icon={InterfaceOkIcon} accessibilityLabel="checklist marker" />
            </div>
            {item}
          </Typography.C4>
        ))}
      </ul>
      <FixedSpacer multiplier={2} />
      <CtaButtonGroup />
    </div>
  )
}
